export default __webpack_public_path__ + "img/fLIkEnGk.4c33f58d.svg";